// extracted by css-extract-rspack-plugin
export default {"viewport":"Tsqqzm_q8iI7FLh4"};